import React from 'react';
import { Box, Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormContext } from 'react-hook-form';

// Import our common form layout components
import FormSelect, {
  FormInput,
  FormDatepicker,
  FormMultiSelect,
  FormAutocomplete,
  FormAutocompleteMultiSelect,
} from './FormControls';
import SupplierField from './SupplierField';

const Return = ({ values }) => {
  const { watch } = useFormContext();

  // Watch values to dynamically show/hide specific nested inputs
  const type = watch('type');
  const showToolAssignedTo = ['Tools', 'Tyres', 'Spare Tyre', 'Other']?.includes(type);

  return (
    <Box sx={{ width: '100%' }}>
      {/* ─── BASIC INFO SECTION ─── */}
      <Accordion defaultExpanded sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            Basic Info
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormDatepicker name="poDate" label="Date" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput name="requestorEmail" label="Requestor Email" placeholder="Enter Email" />
            </Grid>
            
              <SupplierField supplierList={values.supplierList || []} />
           
            <Grid item xs={12} sm={4}>
              <FormInput name="emailToSupplier" label="Supplier Email" placeholder="Enter Supplier Email" />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* ─── REQUEST INFO SECTION ─── */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            Request Info
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormAutocompleteMultiSelect
                name="departmentMachine"
                label="Department / Machine"
                data={values?.departmentList || []}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput name="emailAddresses" label="Email Addresses For Email" placeholder="Enter Email" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput
                name="totalNetValue"
                label="Total Net Value"
                placeholder="Total Value"
                type="number"
                inputProps={{ step: '0.01' }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormSelect name="type" label="Type" options={values['Type']} />
            </Grid>

            {/* Conditional Form Inputs */}
            {showToolAssignedTo && (
              <Grid item xs={12} sm={4}>
                <FormInput
                  name="toolsAssignedTo"
                  label={type === 'Other' ? 'Other' : 'Tools Assigned To'}
                  placeholder={type === 'Other' ? 'Enter other option' : 'Enter name'}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={12}>
              <FormInput
                name="description"
                label="Description"
                placeholder="Enter description"
                multiline
                minRows={4}
                maxRows={10}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Return;
